import {ISplashScreen} from '@/services/splashScreen/types';

export const SplashScreen: ISplashScreen = {
  hide: () => {},
};
